var map = {
	"./change-gallery (1).jpeg": 8162,
	"./change-gallery (10).jpeg": 4448,
	"./change-gallery (11).jpeg": 5757,
	"./change-gallery (12).jpeg": 7650,
	"./change-gallery (13).jpeg": 4239,
	"./change-gallery (14).jpeg": 8556,
	"./change-gallery (15).jpeg": 2121,
	"./change-gallery (16).jpeg": 2494,
	"./change-gallery (2).jpeg": 957,
	"./change-gallery (3).jpeg": 2928,
	"./change-gallery (4).jpeg": 1611,
	"./change-gallery (5).jpeg": 3454,
	"./change-gallery (6).jpeg": 8761,
	"./change-gallery (7).jpeg": 3164,
	"./change-gallery (8).jpeg": 1479,
	"./change-gallery (9).jpeg": 6954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7683;